import React from 'react';
import { GetServerSidePropsContext } from 'next';
import LayoutApp from '@zmedia/bm-soccer-ui/layout';
import { TournamentPageView } from '@zmedia/bm-soccer-ui/modules/tournament';
import PageCustomService from '@zmedia/bm-soccer-ui/service/PageCustomService';
import { IResponse } from 'src/interface';
import { ContainerUI } from 'src/layout/ui';
import { ContentItem } from 'src/modules/content/components/item/ContentItem';
import { ZShortSection } from 'src/modules/event/zshort';

export function Tournament({
    resp,
    isBot,
    isMobile,
}: {
    resp: IResponse<any>;
    isBot: boolean;
    isMobile: boolean;
}) {
    const { data = {} } = resp;
    const { content = {} } = data;
    const { id, activeTab = '' } = content;
    const listProps = {
        ContentItem: ContentItem,
        EventSection:
            activeTab === 'tin-tuc' && id === 150 && isMobile
                ? ZShortSection
                : null,
        ContentItemProps: {
            lazyloadImage: !isBot,
            showDescription: isBot,
            truncateDescription: !isBot,
        },
    };
    return (
        <>
            <ContainerUI {...data} />
            <LayoutApp isMobile={true} {...data}>
                <TournamentPageView {...data} listProps={listProps} />
            </LayoutApp>
        </>
    );
}

export async function getServerSideProps(
    ctx: GetServerSidePropsContext
): Promise<any> {
    const id = ctx?.params?.id;
    const tab = ctx?.params?.tab;
    const seasonId = ctx?.query?.seasonId;
    const resp = await PageCustomService.get(ctx, 'tournament', {
        id: id,
        seasonId: seasonId,
        tab: tab,
    });
    return {
        props: {
            ...resp.props,
            isBlankLayout: true,
        },
    };
}

export default Tournament;
